import React from 'react';

export default function Usuario() {
  return (
    <div>
      <p>Usuario</p>
    </div>
  );
}